/**
 * A study's clinical tags for display: its finalized reports' tags first, then
 * the tags put on the study itself, one chip per label (case-insensitive). A
 * label carried both ways shows once, with the report's qualifier: the signed
 * report is the stronger statement.
 */
export function mergeClinicalTags(reportTags, studyTags) {
    const merged = [...(reportTags ?? [])];
    const seen = new Set(merged.map((tag) => tag.label.toLowerCase()));
    for (const tag of studyTags ?? []) {
        const key = tag.label.toLowerCase();
        if (seen.has(key))
            continue;
        seen.add(key);
        merged.push(tag);
    }
    return merged;
}
